import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Remove16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <g clipPath='url(#clip0_1_435)'>
      <path d='M11.5 8.75V7.25L4.5 7.25V8.75L11.5 8.75Z' fill='currentColor' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8 0.250061C3.71979 0.250061 0.25 3.71985 0.25 8.00006C0.25 12.2803 3.71979 15.7501 8 15.7501C12.2802 15.7501 15.75 12.2803 15.75 8.00006C15.75 3.71985 12.2802 0.250061 8 0.250061ZM1.75 8.00006C1.75 4.54828 4.54822 1.75006 8 1.75006C11.4518 1.75006 14.25 4.54828 14.25 8.00006C14.25 11.4518 11.4518 14.2501 8 14.2501C4.54822 14.2501 1.75 11.4518 1.75 8.00006Z'
        fill='currentColor'
      />
    </g>
    <defs>
      <clipPath id='clip0_1_435'>
        <rect width='16' height='16' fill='white' />
      </clipPath>
    </defs>
  </Svg>
);

Remove16.displayName = 'Remove16';
export default Remove16;
